import Vue from 'vue';
import Component from 'vue-class-component';
import KEYS from '@/values/keys';
import Form from '@/components/form/form';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required, maxLength } from 'vuelidate/lib/validators'
import { AUTH_POPUPS, COMMONS } from '@/auth/values/auth.values';
import { Status } from '@/models/status.model';
import { Watch } from 'vue-property-decorator';

@Component({
  name: 'ed-forgot-password-popup',
  components:{
    ...Form
  }
})
export default class EdForgotPasswordPopup extends Vue {
  public status: Status = new Status();
  public notFound : boolean = false;
  public linkSent : boolean = false;
  public form: any = EdFormModel([
    EdInputModel('input', '', { required, maxLength: maxLength(50) })
  ]);

  async sendLink(){
    let inputVal = this.form.input.value
    try { 
      await this.$Auth.Services.resetPasswordRequest(inputVal)
      this.linkSent = true
    } catch(e) {
      this.notFound = true
      this.status.setError();
    }
  }

  goToLogin() {
    this.$emit('changeView', AUTH_POPUPS.LOGIN);
  }

  @Watch('form.input')
  inputChanged(input:string){
    this.notFound = false;
  }
}
